import { Text } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useEffect, useRef, useState } from 'react';
import { Animated, StyleSheet, View } from 'react-native';

interface HighlightableTextProps {
  children: React.ReactNode;
  shouldHighlight?: boolean;
}

const defaultFontWeight = Typography['fontweight.regular'];
const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
  },
});

export const HighlightableText: React.FC<HighlightableTextProps> = ({
  children,
  shouldHighlight,
}) => {
  const backgroundColor = useRef(new Animated.Value(0));
  const [fontWeight, setFontWeight] = useState<string>(defaultFontWeight);

  // animates background color when shouldHighlight is true
  useEffect(() => {
    if (shouldHighlight) {
      backgroundColor.current.setValue(0);
      Animated.timing(backgroundColor.current, {
        toValue: 1,
        duration: 1000,
        useNativeDriver: true,
      }).start(() => {
        setFontWeight(defaultFontWeight);
      });

      setFontWeight(Typography['fontweight.semibold']);
    }
  }, [shouldHighlight]);

  const currentBackgroundColor = backgroundColor.current.interpolate({
    inputRange: [0, 1],
    outputRange: [`${Color['feedback.gen.lightest']}ff`, `${Color['feedback.gen.lightest']}00`],
  });

  return (
    <View style={styles.container}>
      <Animated.View
        style={{
          backgroundColor: currentBackgroundColor,
          padding: Utils.Token.ToInt(Spacing, 'inline.quarck'),
          borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
        }}>
        <Text
          justifyContent="space-between"
          numberOfLines={1}
          ellipsizeMode="tail"
          fontSize={Typography['fontsize.md']}
          fontWeight={fontWeight}
          textAlign="start">
          {children}
        </Text>
      </Animated.View>
    </View>
  );
};
